import { Controller } from '@hotwired/stimulus';
import initTooltips from 'lib/utils/tooltips';

export default class CollectionsPrivacyControlController extends Controller {
  connect() {
    initTooltips();
  }

  tooltipClick = (event) => {
    event.preventDefault();
  }
}
